import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Link,
} from '@mui/material';

// MESSAGES
import InboxFormattedMessages from '../../../messages/websms/InboxFormattedMessages';

// UTILS
import { getZoneOffsettedDate } from '../../../utils/dates';

const InboxTable = ({
  isSearching,
  received,
  setMessageSelected,
  setMessage,
}) => {
  const renderInboxTable = () => {
    if (isSearching) {
      return (
        <TableRow>
          <TableCell colSpan={4} sx={{ paddingY: 2 }}>
            <Typography>{InboxFormattedMessages.searchingText}</Typography>
          </TableCell>
        </TableRow>
      );
    } else if (received.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={4} sx={{ paddingY: 2 }}>
            <Typography>{InboxFormattedMessages.noResult}</Typography>
          </TableCell>
        </TableRow>
      );
    } else {
      return received.map((message, index) => {
        let smsText;
        try {
          smsText = decodeURIComponent(message.reply_text);
        } catch (err) {
          smsText = 'ERROR: MALFORMED TEXT';
        }

        return (
          <TableRow key={index}>
            <TableCell>{getZoneOffsettedDate(message.created_date)}</TableCell>
            <TableCell>{message.dest_tn}</TableCell>
            <TableCell>{message.dest_name || message.dest_tn || ''}</TableCell>
            <TableCell>
              <Link
                onClick={() => {
                  setMessageSelected(true);
                  setMessage(message);
                }}
                tabIndex={0}
              >
                {smsText}
              </Link>
            </TableCell>
          </TableRow>
        );
      });
    }
  };

  return (
    <TableContainer sx={{ marginBottom: 4, overflowX: 'auto', width: '100%' }}>
      <Table variant="rounded">
        <TableHead>
          <TableRow>
            <TableCell width="20%">
              {InboxFormattedMessages.tableHeaderDate}
            </TableCell>
            <TableCell width="20%">{InboxFormattedMessages.fromText}</TableCell>
            <TableCell width="20%">{InboxFormattedMessages.nameText}</TableCell>
            <TableCell width="40%">
              {InboxFormattedMessages.tableHeaderMessage}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderInboxTable()}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default InboxTable;
